import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutAddStopCompareItems extends Layout {
    sourceEdiCompareItem: DataSource;
    tableCompareItems: Table;
}
